module.exports = __webpack_public_path__ + "img/11_J_hearts.380aed76.png";